module.exports = __webpack_public_path__ + "img/94019.413e2884.svg";